<template>

    <el-dialog title="交班统计" :visible.sync="dialogVisible" width="600px" append-to-body @opened="onDialogOpened"
        @close="onDialogClose">
        <div class="shift-content">
            <!-- 班次信息 -->
            <!-- <div class="shift-info">
                <h3>班次信息</h3>
                <div class="info-row">
                    <span class="label">班次编码：</span>
                    <span class="value">{{ (shiftData.bcInfo && shiftData.bcInfo.bcCode) || '-' }}</span>
                </div>
                <div class="info-row">
                    <span class="label">操作员ID：</span>
                    <span class="value">{{ (shiftData.bcInfo && shiftData.bcInfo.opmId) || '-' }}</span>
                </div>
                <div class="info-row">
                    <span class="label">开始时间：</span>
                    <span class="value">{{ formatTime(shiftData.bcInfo && shiftData.bcInfo.startTime) }}</span>
                </div>
                <div class="info-row">
                    <span class="label">结束时间：</span>
                    <span class="value">{{ formatTime(shiftData.bcInfo && shiftData.bcInfo.endTime) }}</span>
                </div>
            </div> -->

            <!-- 销售统计 -->
            <div class="sales-summary">
                <h3>销售统计</h3>
                <div class="info-row">
                    <span class="label">订单数量：</span>
                    <span class="value highlight">{{ shiftData.orderCount || 0 }} 笔</span>
                </div>
            </div>

            <!-- 收款统计 -->
            <div class="payment-summary">
                <h3>收款统计</h3>
                <div class="payment-list">
                    <div v-for="(item, index) in (shiftData.summaryInfoList || [])" :key="index" class="payment-item">
                        <span class="payment-name">{{ item.abookName || '未知账簿' }}：</span>
                        <span class="payment-amount">￥{{ formatMoney(item.money) }}</span>
                    </div>
                </div>
                <div class="total-amount">
                    <span class="label">总收款金额：</span>
                    <span class="value total">￥{{ formatMoney(totalAmount) }}</span>
                </div>
            </div>
        </div>

        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleConfirm">
                确认交班
            </el-button>
        </div>
    </el-dialog>

</template>

<script>
export default {
    name: 'ShiftDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        bcCode: {
            type: String,
            default: ''
        },
        storeId: {
            type: [String, Number],
            default: ''
        }
    },
    data() {
        return {
            shiftData: {
                bcInfo: {
                    bcCode: '',
                    endTime: 0,
                    id: 0,
                    opmId: 0,
                    startTime: 0,
                    storeId: 0
                },
                orderCount: 0,
                summaryInfoList: []
            }
        }
    },
    computed: {
        dialogVisible: {
            get() {
                return this.visible
            },
            set(val) {
                this.$emit('update:visible', val)
            }
        },
        totalAmount() {
            if (!this.shiftData || !this.shiftData.summaryInfoList) {
                return 0
            }
            return this.shiftData.summaryInfoList.reduce((total, item) => {
                return total + (item.money || 0)
            }, 0)
        }
    },
   
    methods: {
        async onDialogOpened() {
            this.$emit('opened')
            // 使用 nextTick 确保 DOM 完全渲染后再加载数据
            this.$nextTick(async () => {
                await this.loadShiftData()
            })
        },
        onDialogClose() {
            this.$emit('close')
            this.resetData()
        },
        async loadShiftData() {
            if (!this.bcCode) {
                this.$message.warning('班次编码不能为空')
                return
            }

            try {
                const res = await this.$http.getSummaryByBcCode({
                    bcCode: this.bcCode,
                    storeId: this.storeId
                })
                
                if (res && res.status === 200 && res.result) {
                    this.shiftData = {
                        bcInfo: res.result.bcInfo ,
                        orderCount: res.result.orderCount || 0,
                        summaryInfoList: res.result.summaryInfoList || []
                    }
                    console.log('交班数据设置完成:', this.shiftData)
                    // 强制更新视图
                    this.$forceUpdate()
                    // 确保数据已经更新到视图
                    this.$nextTick(() => {
                        console.log('视图更新完成')
                    })
                } else {
                    this.$message.error('获取交班数据失败')
                    console.error('接口返回错误:', res)
                }
            } catch (error) {
                console.error('获取交班数据失败:', error)
                this.$message.error('获取交班数据失败')
            }
        },
        formatTime(timestamp) {
            if (!timestamp) return '-'
            const date = new Date(timestamp)
            return date.toLocaleString('zh-CN', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            })
        },
        formatMoney(amount) {
            if (typeof amount !== 'number') return '0.00'
            return amount.toFixed(2)
        },
        handleCancel() {
            this.dialogVisible = false
        },
        async handleConfirm() {

            try {
                // 触发确认事件，让父组件处理交班逻辑
                this.$emit('confirm', this.shiftData)
                this.dialogVisible = false
            } catch (error) {
                console.error('交班确认失败:', error)
            }
        },
        resetData() {
            this.shiftData = {
                bcInfo: {
                    bcCode: '',
                    endTime: 0,
                    id: 0,
                    opmId: 0,
                    startTime: 0,
                    storeId: 0
                },
                orderCount: 0,
                summaryInfoList: []
            }
        }
    }
}
</script>

<style scoped>
.shift-content {
    padding: 10px 0;
}

.shift-info,
.sales-summary,
.payment-summary {
    margin-bottom: 20px;
    padding: 15px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    background-color: #fafafa;
}

.shift-info h3,
.sales-summary h3,
.payment-summary h3 {
    margin: 0 0 15px 0;
    color: #303133;
    font-size: 16px;
    font-weight: bold;
    border-bottom: 2px solid #409eff;
    padding-bottom: 5px;
}

.info-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    padding: 8px 0;
}

.info-row:last-child {
    margin-bottom: 0;
}

.label {
    font-weight: 500;
    color: #606266;
    min-width: 100px;
}

.value {
    color: #303133;
    font-weight: 500;
}

.value.highlight {
    color: #409eff;
    font-size: 18px;
    font-weight: bold;
}

.value.total {
    color: #e6a23c;
    font-size: 20px;
    font-weight: bold;
}

.payment-list {
    margin-bottom: 15px;
}

.payment-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #ebeef5;
}

.payment-item:last-child {
    border-bottom: none;
}

.payment-name {
    color: #606266;
    font-weight: 500;
}

.payment-amount {
    color: #67c23a;
    font-weight: bold;
    font-size: 16px;
}

.total-amount {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0 10px 0;
    border-top: 2px solid #409eff;
    margin-top: 10px;
}

.dialog-footer {
    text-align: right;
}

.dialog-footer .el-button {
    margin-left: 10px;
}
</style>